/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.11.1.0 (NJsonSchema v10.4.3.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming



export class BasePermissions {

    init(_data?: any) {
    }

    static fromJS(data: any): BasePermissions {
        data = typeof data === 'object' ? data : {};
        let result = new BasePermissions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): BasePermissions {
        const json = this.toJSON();
        let result = new BasePermissions();
        result.init(json);
        return result;
    }
}

export class ActivityPermissionCommand extends BasePermissions {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ActivityPermissionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityPermissionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): ActivityPermissionCommand {
        const json = this.toJSON();
        let result = new ActivityPermissionCommand();
        result.init(json);
        return result;
    }
}

export class GetActivitiesDtosRequest {
    includes?: GetActivitiesDtosIncludeOptions | undefined;

    init(_data?: any) {
        if (_data) {
            this.includes = _data["includes"] ? GetActivitiesDtosIncludeOptions.fromJS(_data["includes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetActivitiesDtosRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivitiesDtosRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includes"] = this.includes ? this.includes.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetActivitiesDtosRequest {
        const json = this.toJSON();
        let result = new GetActivitiesDtosRequest();
        result.init(json);
        return result;
    }
}

export class GetActivitiesDtosListRequest extends GetActivitiesDtosRequest {
    skip?: number | undefined;
    take?: number | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): GetActivitiesDtosListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivitiesDtosListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skip"] = this.skip;
        data["take"] = this.take;
        super.toJSON(data);
        return data; 
    }

    clone(): GetActivitiesDtosListRequest {
        const json = this.toJSON();
        let result = new GetActivitiesDtosListRequest();
        result.init(json);
        return result;
    }
}

export class GetActivitiesDtosQuery extends GetActivitiesDtosListRequest {
    idLanguage?: number;
    idActivityType?: number | undefined;
    idActivityStatus?: number | undefined;
    idActivityArea?: number | undefined;
    idActivityPriority?: number | undefined;
    idEntity?: number | undefined;
    title?: string | undefined;
    search?: string | undefined;
    orderBy?: GetActivitiesDtosOrderOptions | undefined;
    period?: GetActivitiesDtosPeriodOptions;
    privacy?: GetActivitiesDtosPrivacyOptions;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idActivityType = _data["idActivityType"];
            this.idActivityStatus = _data["idActivityStatus"];
            this.idActivityArea = _data["idActivityArea"];
            this.idActivityPriority = _data["idActivityPriority"];
            this.idEntity = _data["idEntity"];
            this.title = _data["title"];
            this.search = _data["search"];
            this.orderBy = _data["orderBy"];
            this.period = _data["period"];
            this.privacy = _data["privacy"];
        }
    }

    static fromJS(data: any): GetActivitiesDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivitiesDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idActivityType"] = this.idActivityType;
        data["idActivityStatus"] = this.idActivityStatus;
        data["idActivityArea"] = this.idActivityArea;
        data["idActivityPriority"] = this.idActivityPriority;
        data["idEntity"] = this.idEntity;
        data["title"] = this.title;
        data["search"] = this.search;
        data["orderBy"] = this.orderBy;
        data["period"] = this.period;
        data["privacy"] = this.privacy;
        super.toJSON(data);
        return data; 
    }

    clone(): GetActivitiesDtosQuery {
        const json = this.toJSON();
        let result = new GetActivitiesDtosQuery();
        result.init(json);
        return result;
    }
}

export enum GetActivitiesDtosOrderOptions {
    TitleAsc = 0,
    TitleDesc = 1,
    DateCreatedAsc = 2,
    DateCreatedDesc = 3,
    DateStartAsc = 4,
    DateStartDesc = 5,
}

export enum GetActivitiesDtosPeriodOptions {
    All = 0,
    Today = 1,
    Week = 2,
    Month = 3,
}

export enum GetActivitiesDtosPrivacyOptions {
    Mine = 1,
    All = 2,
}

export class GetActivitiesDtosIncludeOptions {
    activityType?: boolean;
    activityArea?: boolean;
    activityStatus?: boolean;
    activityPriority?: boolean;
    assignees?: boolean;
    appGroups?: boolean;
    tags?: boolean;
    metadata?: boolean;
    activityLogtimes?: boolean;
    entity?: boolean;

    init(_data?: any) {
        if (_data) {
            this.activityType = _data["activityType"];
            this.activityArea = _data["activityArea"];
            this.activityStatus = _data["activityStatus"];
            this.activityPriority = _data["activityPriority"];
            this.assignees = _data["assignees"];
            this.appGroups = _data["appGroups"];
            this.tags = _data["tags"];
            this.metadata = _data["metadata"];
            this.activityLogtimes = _data["activityLogtimes"];
            this.entity = _data["entity"];
        }
    }

    static fromJS(data: any): GetActivitiesDtosIncludeOptions {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivitiesDtosIncludeOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType;
        data["activityArea"] = this.activityArea;
        data["activityStatus"] = this.activityStatus;
        data["activityPriority"] = this.activityPriority;
        data["assignees"] = this.assignees;
        data["appGroups"] = this.appGroups;
        data["tags"] = this.tags;
        data["metadata"] = this.metadata;
        data["activityLogtimes"] = this.activityLogtimes;
        data["entity"] = this.entity;
        return data; 
    }

    clone(): GetActivitiesDtosIncludeOptions {
        const json = this.toJSON();
        let result = new GetActivitiesDtosIncludeOptions();
        result.init(json);
        return result;
    }
}

export class GetActivityCommentsDtosQuery {
    idLanguage?: number;
    idActivity?: number;
    isPublic?: boolean | undefined;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idActivity = _data["idActivity"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): GetActivityCommentsDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityCommentsDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idActivity"] = this.idActivity;
        data["isPublic"] = this.isPublic;
        return data; 
    }

    clone(): GetActivityCommentsDtosQuery {
        const json = this.toJSON();
        let result = new GetActivityCommentsDtosQuery();
        result.init(json);
        return result;
    }
}

export class GetActivityDtoQuery extends GetActivitiesDtosListRequest {
    idLanguage?: number;
    idActivity?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idActivity = _data["idActivity"];
        }
    }

    static fromJS(data: any): GetActivityDtoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityDtoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idActivity"] = this.idActivity;
        super.toJSON(data);
        return data; 
    }

    clone(): GetActivityDtoQuery {
        const json = this.toJSON();
        let result = new GetActivityDtoQuery();
        result.init(json);
        return result;
    }
}

export class GetActivityFilesDtosQuery {
    idLanguage?: number;
    idActivity?: number;
    isPublic?: boolean | undefined;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idActivity = _data["idActivity"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): GetActivityFilesDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityFilesDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idActivity"] = this.idActivity;
        data["isPublic"] = this.isPublic;
        return data; 
    }

    clone(): GetActivityFilesDtosQuery {
        const json = this.toJSON();
        let result = new GetActivityFilesDtosQuery();
        result.init(json);
        return result;
    }
}

export class GetActivityLogtimesDtosQuery {
    idLanguage?: number;
    idActivity?: number;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idActivity = _data["idActivity"];
        }
    }

    static fromJS(data: any): GetActivityLogtimesDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityLogtimesDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idActivity"] = this.idActivity;
        return data; 
    }

    clone(): GetActivityLogtimesDtosQuery {
        const json = this.toJSON();
        let result = new GetActivityLogtimesDtosQuery();
        result.init(json);
        return result;
    }
}

export class GetActivityMetadataDtoQuery {
    idActivity?: number;
    idLanguage?: number;

    init(_data?: any) {
        if (_data) {
            this.idActivity = _data["idActivity"];
            this.idLanguage = _data["idLanguage"];
        }
    }

    static fromJS(data: any): GetActivityMetadataDtoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityMetadataDtoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivity"] = this.idActivity;
        data["idLanguage"] = this.idLanguage;
        return data; 
    }

    clone(): GetActivityMetadataDtoQuery {
        const json = this.toJSON();
        let result = new GetActivityMetadataDtoQuery();
        result.init(json);
        return result;
    }
}

export class GetActivityStatisticsDtoQuery {
    idActivity?: number;

    init(_data?: any) {
        if (_data) {
            this.idActivity = _data["idActivity"];
        }
    }

    static fromJS(data: any): GetActivityStatisticsDtoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityStatisticsDtoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivity"] = this.idActivity;
        return data; 
    }

    clone(): GetActivityStatisticsDtoQuery {
        const json = this.toJSON();
        let result = new GetActivityStatisticsDtoQuery();
        result.init(json);
        return result;
    }
}

export class GetLastActivityLogtimeWorkDtoQuery {
    idActivity?: number;

    init(_data?: any) {
        if (_data) {
            this.idActivity = _data["idActivity"];
        }
    }

    static fromJS(data: any): GetLastActivityLogtimeWorkDtoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetLastActivityLogtimeWorkDtoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivity"] = this.idActivity;
        return data; 
    }

    clone(): GetLastActivityLogtimeWorkDtoQuery {
        const json = this.toJSON();
        let result = new GetLastActivityLogtimeWorkDtoQuery();
        result.init(json);
        return result;
    }
}

export class GetActivityAreaDtosQuery {
    idLanguage?: number;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
        }
    }

    static fromJS(data: any): GetActivityAreaDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityAreaDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        return data; 
    }

    clone(): GetActivityAreaDtosQuery {
        const json = this.toJSON();
        let result = new GetActivityAreaDtosQuery();
        result.init(json);
        return result;
    }
}

export class GetActivityAreaMetadataGroupsConfigurationDtoQuery {
    idLanguage?: number;
    idActivityArea?: number;
    visibleOnCreate?: boolean | undefined;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idActivityArea = _data["idActivityArea"];
            this.visibleOnCreate = _data["visibleOnCreate"];
        }
    }

    static fromJS(data: any): GetActivityAreaMetadataGroupsConfigurationDtoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityAreaMetadataGroupsConfigurationDtoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idActivityArea"] = this.idActivityArea;
        data["visibleOnCreate"] = this.visibleOnCreate;
        return data; 
    }

    clone(): GetActivityAreaMetadataGroupsConfigurationDtoQuery {
        const json = this.toJSON();
        let result = new GetActivityAreaMetadataGroupsConfigurationDtoQuery();
        result.init(json);
        return result;
    }
}

export class GetActivityPrioritiesDtosQuery {
    idLanguage?: number;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
        }
    }

    static fromJS(data: any): GetActivityPrioritiesDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityPrioritiesDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        return data; 
    }

    clone(): GetActivityPrioritiesDtosQuery {
        const json = this.toJSON();
        let result = new GetActivityPrioritiesDtosQuery();
        result.init(json);
        return result;
    }
}

export class GetActivityStatusDtosQuery {
    idLanguage?: number;
    idActivityArea?: number | undefined;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idActivityArea = _data["idActivityArea"];
        }
    }

    static fromJS(data: any): GetActivityStatusDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityStatusDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idActivityArea"] = this.idActivityArea;
        return data; 
    }

    clone(): GetActivityStatusDtosQuery {
        const json = this.toJSON();
        let result = new GetActivityStatusDtosQuery();
        result.init(json);
        return result;
    }
}

export class GetActivityTypesDtosQuery {
    idLanguage?: number;
    idActivityArea?: number | undefined;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idActivityArea = _data["idActivityArea"];
        }
    }

    static fromJS(data: any): GetActivityTypesDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityTypesDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idActivityArea"] = this.idActivityArea;
        return data; 
    }

    clone(): GetActivityTypesDtosQuery {
        const json = this.toJSON();
        let result = new GetActivityTypesDtosQuery();
        result.init(json);
        return result;
    }
}

export class GetAppGroupDtoQuery {
    idAppGroup?: number;

    init(_data?: any) {
        if (_data) {
            this.idAppGroup = _data["idAppGroup"];
        }
    }

    static fromJS(data: any): GetAppGroupDtoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppGroupDtoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idAppGroup"] = this.idAppGroup;
        return data; 
    }

    clone(): GetAppGroupDtoQuery {
        const json = this.toJSON();
        let result = new GetAppGroupDtoQuery();
        result.init(json);
        return result;
    }
}

export class GetAppGroupsDtosQuery {

    init(_data?: any) {
    }

    static fromJS(data: any): GetAppGroupsDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppGroupsDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): GetAppGroupsDtosQuery {
        const json = this.toJSON();
        let result = new GetAppGroupsDtosQuery();
        result.init(json);
        return result;
    }
}

export class GetAppInterfaceModulesDtosQuery {
    idAppInterface?: number;

    init(_data?: any) {
        if (_data) {
            this.idAppInterface = _data["idAppInterface"];
        }
    }

    static fromJS(data: any): GetAppInterfaceModulesDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppInterfaceModulesDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idAppInterface"] = this.idAppInterface;
        return data; 
    }

    clone(): GetAppInterfaceModulesDtosQuery {
        const json = this.toJSON();
        let result = new GetAppInterfaceModulesDtosQuery();
        result.init(json);
        return result;
    }
}

export class GetAppInterfaceRolesDtosQuery {
    idLanguage?: number;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
        }
    }

    static fromJS(data: any): GetAppInterfaceRolesDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppInterfaceRolesDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        return data; 
    }

    clone(): GetAppInterfaceRolesDtosQuery {
        const json = this.toJSON();
        let result = new GetAppInterfaceRolesDtosQuery();
        result.init(json);
        return result;
    }
}

export class GetEntitiesDtosRequest {
    includes?: GetEntitiesDtosIncludeOptions | undefined;

    init(_data?: any) {
        if (_data) {
            this.includes = _data["includes"] ? GetEntitiesDtosIncludeOptions.fromJS(_data["includes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEntitiesDtosRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetEntitiesDtosRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includes"] = this.includes ? this.includes.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetEntitiesDtosRequest {
        const json = this.toJSON();
        let result = new GetEntitiesDtosRequest();
        result.init(json);
        return result;
    }
}

export class GetEntitiesDtosListRequest extends GetEntitiesDtosRequest {
    skip?: number | undefined;
    take?: number | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): GetEntitiesDtosListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetEntitiesDtosListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skip"] = this.skip;
        data["take"] = this.take;
        super.toJSON(data);
        return data; 
    }

    clone(): GetEntitiesDtosListRequest {
        const json = this.toJSON();
        let result = new GetEntitiesDtosListRequest();
        result.init(json);
        return result;
    }
}

export class GetEntitiesDtosQuery extends GetEntitiesDtosListRequest {
    idLanguage?: number;
    idEntityGroup?: number | undefined;
    idEntityType?: number | undefined;
    isCompany?: boolean | undefined;
    name?: string | undefined;
    fiscalIdNumber?: string | undefined;
    orderBy?: GetEntitiesDtosOrderOptions | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idEntityGroup = _data["idEntityGroup"];
            this.idEntityType = _data["idEntityType"];
            this.isCompany = _data["isCompany"];
            this.name = _data["name"];
            this.fiscalIdNumber = _data["fiscalIdNumber"];
            this.orderBy = _data["orderBy"];
        }
    }

    static fromJS(data: any): GetEntitiesDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetEntitiesDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idEntityGroup"] = this.idEntityGroup;
        data["idEntityType"] = this.idEntityType;
        data["isCompany"] = this.isCompany;
        data["name"] = this.name;
        data["fiscalIdNumber"] = this.fiscalIdNumber;
        data["orderBy"] = this.orderBy;
        super.toJSON(data);
        return data; 
    }

    clone(): GetEntitiesDtosQuery {
        const json = this.toJSON();
        let result = new GetEntitiesDtosQuery();
        result.init(json);
        return result;
    }
}

export enum GetEntitiesDtosOrderOptions {
    NameAsc = 0,
    NameDesc = 1,
    FiscalIdNumberAsc = 2,
    FiscalIdNumberDesc = 3,
}

export class GetEntitiesDtosIncludeOptions {
    entityGroup?: boolean;
    entityType?: boolean;

    init(_data?: any) {
        if (_data) {
            this.entityGroup = _data["entityGroup"];
            this.entityType = _data["entityType"];
        }
    }

    static fromJS(data: any): GetEntitiesDtosIncludeOptions {
        data = typeof data === 'object' ? data : {};
        let result = new GetEntitiesDtosIncludeOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityGroup"] = this.entityGroup;
        data["entityType"] = this.entityType;
        return data; 
    }

    clone(): GetEntitiesDtosIncludeOptions {
        const json = this.toJSON();
        let result = new GetEntitiesDtosIncludeOptions();
        result.init(json);
        return result;
    }
}

export class GetEntityCommentsDtosQuery {
    idLanguage?: number;
    idEntity?: number;
    isPublic?: boolean | undefined;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idEntity = _data["idEntity"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): GetEntityCommentsDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetEntityCommentsDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idEntity"] = this.idEntity;
        data["isPublic"] = this.isPublic;
        return data; 
    }

    clone(): GetEntityCommentsDtosQuery {
        const json = this.toJSON();
        let result = new GetEntityCommentsDtosQuery();
        result.init(json);
        return result;
    }
}

export class GetEntitiesDtosSingleRequest extends GetEntitiesDtosRequest {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetEntitiesDtosSingleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetEntitiesDtosSingleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): GetEntitiesDtosSingleRequest {
        const json = this.toJSON();
        let result = new GetEntitiesDtosSingleRequest();
        result.init(json);
        return result;
    }
}

export class GetEntityDtoQuery extends GetEntitiesDtosSingleRequest {
    idEntity?: number;
    idLanguage?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idEntity = _data["idEntity"];
            this.idLanguage = _data["idLanguage"];
        }
    }

    static fromJS(data: any): GetEntityDtoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetEntityDtoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntity"] = this.idEntity;
        data["idLanguage"] = this.idLanguage;
        super.toJSON(data);
        return data; 
    }

    clone(): GetEntityDtoQuery {
        const json = this.toJSON();
        let result = new GetEntityDtoQuery();
        result.init(json);
        return result;
    }
}

export class GetEntityFilesDtosQuery {
    idLanguage?: number;
    idEntity?: number;
    isPublic?: boolean | undefined;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idEntity = _data["idEntity"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): GetEntityFilesDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetEntityFilesDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idEntity"] = this.idEntity;
        data["isPublic"] = this.isPublic;
        return data; 
    }

    clone(): GetEntityFilesDtosQuery {
        const json = this.toJSON();
        let result = new GetEntityFilesDtosQuery();
        result.init(json);
        return result;
    }
}

export class GetEntityMetadataDtoQuery {
    idEntity?: number;
    idLanguage?: number;

    init(_data?: any) {
        if (_data) {
            this.idEntity = _data["idEntity"];
            this.idLanguage = _data["idLanguage"];
        }
    }

    static fromJS(data: any): GetEntityMetadataDtoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetEntityMetadataDtoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntity"] = this.idEntity;
        data["idLanguage"] = this.idLanguage;
        return data; 
    }

    clone(): GetEntityMetadataDtoQuery {
        const json = this.toJSON();
        let result = new GetEntityMetadataDtoQuery();
        result.init(json);
        return result;
    }
}

export class GetUserFilesDtosQuery {
    idLanguage?: number;
    idUser?: number;
    isPublic?: boolean | undefined;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idUser = _data["idUser"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): GetUserFilesDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserFilesDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idUser"] = this.idUser;
        data["isPublic"] = this.isPublic;
        return data; 
    }

    clone(): GetUserFilesDtosQuery {
        const json = this.toJSON();
        let result = new GetUserFilesDtosQuery();
        result.init(json);
        return result;
    }
}

export class GetEntityGroupsDtosQuery {
    idLanguage?: number;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
        }
    }

    static fromJS(data: any): GetEntityGroupsDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetEntityGroupsDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        return data; 
    }

    clone(): GetEntityGroupsDtosQuery {
        const json = this.toJSON();
        let result = new GetEntityGroupsDtosQuery();
        result.init(json);
        return result;
    }
}

export class GetEntityLogsDtosQuery {
    idEntity?: number;
    typeId?: EntityLogTypes | undefined;

    init(_data?: any) {
        if (_data) {
            this.idEntity = _data["idEntity"];
            this.typeId = _data["typeId"];
        }
    }

    static fromJS(data: any): GetEntityLogsDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetEntityLogsDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntity"] = this.idEntity;
        data["typeId"] = this.typeId;
        return data; 
    }

    clone(): GetEntityLogsDtosQuery {
        const json = this.toJSON();
        let result = new GetEntityLogsDtosQuery();
        result.init(json);
        return result;
    }
}

export enum EntityLogTypes {
    Created = 0,
    Edited = 1,
}

export class GetEntitySectorsDtosQuery {
    idLanguage?: number;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
        }
    }

    static fromJS(data: any): GetEntitySectorsDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetEntitySectorsDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        return data; 
    }

    clone(): GetEntitySectorsDtosQuery {
        const json = this.toJSON();
        let result = new GetEntitySectorsDtosQuery();
        result.init(json);
        return result;
    }
}

export class GetEntityTypeMetadataGroupsConfigurationDtoQuery {
    idLanguage?: number;
    idEntityType?: number;
    visibleOnCreate?: boolean | undefined;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idEntityType = _data["idEntityType"];
            this.visibleOnCreate = _data["visibleOnCreate"];
        }
    }

    static fromJS(data: any): GetEntityTypeMetadataGroupsConfigurationDtoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetEntityTypeMetadataGroupsConfigurationDtoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idEntityType"] = this.idEntityType;
        data["visibleOnCreate"] = this.visibleOnCreate;
        return data; 
    }

    clone(): GetEntityTypeMetadataGroupsConfigurationDtoQuery {
        const json = this.toJSON();
        let result = new GetEntityTypeMetadataGroupsConfigurationDtoQuery();
        result.init(json);
        return result;
    }
}

export class GetEntityTypesDtosQuery {
    idLanguage?: number;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
        }
    }

    static fromJS(data: any): GetEntityTypesDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetEntityTypesDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        return data; 
    }

    clone(): GetEntityTypesDtosQuery {
        const json = this.toJSON();
        let result = new GetEntityTypesDtosQuery();
        result.init(json);
        return result;
    }
}

export class GetFeedbackAnswersDtosRequest {
    includes?: GetFeedbackAnswersDtosIncludeOptions | undefined;

    init(_data?: any) {
        if (_data) {
            this.includes = _data["includes"] ? GetFeedbackAnswersDtosIncludeOptions.fromJS(_data["includes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFeedbackAnswersDtosRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackAnswersDtosRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includes"] = this.includes ? this.includes.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetFeedbackAnswersDtosRequest {
        const json = this.toJSON();
        let result = new GetFeedbackAnswersDtosRequest();
        result.init(json);
        return result;
    }
}

export class GetFeedbackAnswersDtosListRequest extends GetFeedbackAnswersDtosRequest {
    skip?: number | undefined;
    take?: number | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): GetFeedbackAnswersDtosListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackAnswersDtosListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skip"] = this.skip;
        data["take"] = this.take;
        super.toJSON(data);
        return data; 
    }

    clone(): GetFeedbackAnswersDtosListRequest {
        const json = this.toJSON();
        let result = new GetFeedbackAnswersDtosListRequest();
        result.init(json);
        return result;
    }
}

export class GetFeedbackAnswerDtosQuery extends GetFeedbackAnswersDtosListRequest {
    idFeedbackQuestion?: number | undefined;
    idFeedbackQuestionGroup?: number | undefined;
    idUser?: number | undefined;
    idUserRequest?: number | undefined;
    idUserResponse?: number | undefined;
    idFeedbackType?: number | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idFeedbackQuestion = _data["idFeedbackQuestion"];
            this.idFeedbackQuestionGroup = _data["idFeedbackQuestionGroup"];
            this.idUser = _data["idUser"];
            this.idUserRequest = _data["idUserRequest"];
            this.idUserResponse = _data["idUserResponse"];
            this.idFeedbackType = _data["idFeedbackType"];
        }
    }

    static fromJS(data: any): GetFeedbackAnswerDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackAnswerDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackQuestion"] = this.idFeedbackQuestion;
        data["idFeedbackQuestionGroup"] = this.idFeedbackQuestionGroup;
        data["idUser"] = this.idUser;
        data["idUserRequest"] = this.idUserRequest;
        data["idUserResponse"] = this.idUserResponse;
        data["idFeedbackType"] = this.idFeedbackType;
        super.toJSON(data);
        return data; 
    }

    clone(): GetFeedbackAnswerDtosQuery {
        const json = this.toJSON();
        let result = new GetFeedbackAnswerDtosQuery();
        result.init(json);
        return result;
    }
}

export class GetFeedbackAnswersDtosIncludeOptions {
    feedbackQuestion?: boolean;
    feedbackQuestionGroup?: boolean;
    user?: boolean;

    init(_data?: any) {
        if (_data) {
            this.feedbackQuestion = _data["feedbackQuestion"];
            this.feedbackQuestionGroup = _data["feedbackQuestionGroup"];
            this.user = _data["user"];
        }
    }

    static fromJS(data: any): GetFeedbackAnswersDtosIncludeOptions {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackAnswersDtosIncludeOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feedbackQuestion"] = this.feedbackQuestion;
        data["feedbackQuestionGroup"] = this.feedbackQuestionGroup;
        data["user"] = this.user;
        return data; 
    }

    clone(): GetFeedbackAnswersDtosIncludeOptions {
        const json = this.toJSON();
        let result = new GetFeedbackAnswersDtosIncludeOptions();
        result.init(json);
        return result;
    }
}

export class GetSingleFeedbackAnswerDtoQuery extends GetFeedbackAnswersDtosListRequest {
    idLanguage?: number;
    idFeedbackAnswer?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idFeedbackAnswer = _data["idFeedbackAnswer"];
        }
    }

    static fromJS(data: any): GetSingleFeedbackAnswerDtoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSingleFeedbackAnswerDtoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idFeedbackAnswer"] = this.idFeedbackAnswer;
        super.toJSON(data);
        return data; 
    }

    clone(): GetSingleFeedbackAnswerDtoQuery {
        const json = this.toJSON();
        let result = new GetSingleFeedbackAnswerDtoQuery();
        result.init(json);
        return result;
    }
}

export class GetFeedbackCommentsDtosRequest {
    includes?: GetFeedbackCommentsDtosIncludeOptions | undefined;

    init(_data?: any) {
        if (_data) {
            this.includes = _data["includes"] ? GetFeedbackCommentsDtosIncludeOptions.fromJS(_data["includes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFeedbackCommentsDtosRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackCommentsDtosRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includes"] = this.includes ? this.includes.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetFeedbackCommentsDtosRequest {
        const json = this.toJSON();
        let result = new GetFeedbackCommentsDtosRequest();
        result.init(json);
        return result;
    }
}

export class GetFeedbackCommentsDtosListRequest extends GetFeedbackCommentsDtosRequest {
    skip?: number | undefined;
    take?: number | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): GetFeedbackCommentsDtosListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackCommentsDtosListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skip"] = this.skip;
        data["take"] = this.take;
        super.toJSON(data);
        return data; 
    }

    clone(): GetFeedbackCommentsDtosListRequest {
        const json = this.toJSON();
        let result = new GetFeedbackCommentsDtosListRequest();
        result.init(json);
        return result;
    }
}

export class GetFeedbackCommentDtosQuery extends GetFeedbackCommentsDtosListRequest {
    idLanguage?: number | undefined;
    idFeedback?: number | undefined;
    idUser?: number | undefined;
    isPublic?: boolean | undefined;
    orderBy?: GetFeedbackCommentsDtosOrderOptions | undefined;
    period?: GetFeedbackCommentsDtosPeriodOptions;
    privacy?: GetFeedbackCommentsDtosPrivacyOptions;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idFeedback = _data["idFeedback"];
            this.idUser = _data["idUser"];
            this.isPublic = _data["isPublic"];
            this.orderBy = _data["orderBy"];
            this.period = _data["period"];
            this.privacy = _data["privacy"];
        }
    }

    static fromJS(data: any): GetFeedbackCommentDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackCommentDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idFeedback"] = this.idFeedback;
        data["idUser"] = this.idUser;
        data["isPublic"] = this.isPublic;
        data["orderBy"] = this.orderBy;
        data["period"] = this.period;
        data["privacy"] = this.privacy;
        super.toJSON(data);
        return data; 
    }

    clone(): GetFeedbackCommentDtosQuery {
        const json = this.toJSON();
        let result = new GetFeedbackCommentDtosQuery();
        result.init(json);
        return result;
    }
}

export enum GetFeedbackCommentsDtosOrderOptions {
    TitleAsc = 0,
    TitleDesc = 1,
    DateCreatedAsc = 2,
    DateCreatedDesc = 3,
    DateStartAsc = 4,
    DateStartDesc = 5,
}

export enum GetFeedbackCommentsDtosPeriodOptions {
    All = 0,
    Today = 1,
    Week = 2,
    Month = 3,
}

export enum GetFeedbackCommentsDtosPrivacyOptions {
    Mine = 1,
    All = 2,
}

export class GetFeedbackCommentsDtosIncludeOptions {
    feedback?: boolean;
    user?: boolean;

    init(_data?: any) {
        if (_data) {
            this.feedback = _data["feedback"];
            this.user = _data["user"];
        }
    }

    static fromJS(data: any): GetFeedbackCommentsDtosIncludeOptions {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackCommentsDtosIncludeOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feedback"] = this.feedback;
        data["user"] = this.user;
        return data; 
    }

    clone(): GetFeedbackCommentsDtosIncludeOptions {
        const json = this.toJSON();
        let result = new GetFeedbackCommentsDtosIncludeOptions();
        result.init(json);
        return result;
    }
}

export class GetSingleFeedbackCommentDtoQuery extends GetFeedbackCommentsDtosListRequest {
    idLanguage?: number;
    idFeedbackComment?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idFeedbackComment = _data["idFeedbackComment"];
        }
    }

    static fromJS(data: any): GetSingleFeedbackCommentDtoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSingleFeedbackCommentDtoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idFeedbackComment"] = this.idFeedbackComment;
        super.toJSON(data);
        return data; 
    }

    clone(): GetSingleFeedbackCommentDtoQuery {
        const json = this.toJSON();
        let result = new GetSingleFeedbackCommentDtoQuery();
        result.init(json);
        return result;
    }
}

export class GetFeedbackQuestionGroupDtosRequest {
    includes?: GetFeedbackQuestionGroupDtosIncludeOptions | undefined;

    init(_data?: any) {
        if (_data) {
            this.includes = _data["includes"] ? GetFeedbackQuestionGroupDtosIncludeOptions.fromJS(_data["includes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFeedbackQuestionGroupDtosRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackQuestionGroupDtosRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includes"] = this.includes ? this.includes.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetFeedbackQuestionGroupDtosRequest {
        const json = this.toJSON();
        let result = new GetFeedbackQuestionGroupDtosRequest();
        result.init(json);
        return result;
    }
}

export class GetFeedbackQuestionGroupsDtosListRequest extends GetFeedbackQuestionGroupDtosRequest {
    skip?: number | undefined;
    take?: number | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): GetFeedbackQuestionGroupsDtosListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackQuestionGroupsDtosListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skip"] = this.skip;
        data["take"] = this.take;
        super.toJSON(data);
        return data; 
    }

    clone(): GetFeedbackQuestionGroupsDtosListRequest {
        const json = this.toJSON();
        let result = new GetFeedbackQuestionGroupsDtosListRequest();
        result.init(json);
        return result;
    }
}

export class GetFeedbackQuestionGroupDtosQuery extends GetFeedbackQuestionGroupsDtosListRequest {
    idLanguage?: number;
    idFeedback?: number | undefined;
    search?: string;
    orderBy?: GetFeedbackQuestionGroupsDtosOrderOptions | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idFeedback = _data["idFeedback"];
            this.search = _data["search"];
            this.orderBy = _data["orderBy"];
        }
    }

    static fromJS(data: any): GetFeedbackQuestionGroupDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackQuestionGroupDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idFeedback"] = this.idFeedback;
        data["search"] = this.search;
        data["orderBy"] = this.orderBy;
        super.toJSON(data);
        return data; 
    }

    clone(): GetFeedbackQuestionGroupDtosQuery {
        const json = this.toJSON();
        let result = new GetFeedbackQuestionGroupDtosQuery();
        result.init(json);
        return result;
    }
}

export enum GetFeedbackQuestionGroupsDtosOrderOptions {
    TitleAsc = 0,
    TitleDesc = 1,
    Reflection = 2,
    OrderId = 3,
    OrderIdDesc = 4,
    TypeId = 5,
    TypeIdDesc = 6,
}

export class GetFeedbackQuestionGroupDtosIncludeOptions {
    feedback?: boolean;
    feedbackQuestions?: boolean;

    init(_data?: any) {
        if (_data) {
            this.feedback = _data["feedback"];
            this.feedbackQuestions = _data["feedbackQuestions"];
        }
    }

    static fromJS(data: any): GetFeedbackQuestionGroupDtosIncludeOptions {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackQuestionGroupDtosIncludeOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feedback"] = this.feedback;
        data["feedbackQuestions"] = this.feedbackQuestions;
        return data; 
    }

    clone(): GetFeedbackQuestionGroupDtosIncludeOptions {
        const json = this.toJSON();
        let result = new GetFeedbackQuestionGroupDtosIncludeOptions();
        result.init(json);
        return result;
    }
}

export class GetSingleFeedbackQuestionGroupDtoQuery extends GetFeedbackQuestionGroupsDtosListRequest {
    idLanguage?: number;
    idFeedbackQuestionGroup?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idFeedbackQuestionGroup = _data["idFeedbackQuestionGroup"];
        }
    }

    static fromJS(data: any): GetSingleFeedbackQuestionGroupDtoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSingleFeedbackQuestionGroupDtoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idFeedbackQuestionGroup"] = this.idFeedbackQuestionGroup;
        super.toJSON(data);
        return data; 
    }

    clone(): GetSingleFeedbackQuestionGroupDtoQuery {
        const json = this.toJSON();
        let result = new GetSingleFeedbackQuestionGroupDtoQuery();
        result.init(json);
        return result;
    }
}

export class GetFeedbackQuestionsDtosRequest {
    includes?: GetFeedbackQuestionsDtosIncludeOptions | undefined;

    init(_data?: any) {
        if (_data) {
            this.includes = _data["includes"] ? GetFeedbackQuestionsDtosIncludeOptions.fromJS(_data["includes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFeedbackQuestionsDtosRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackQuestionsDtosRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includes"] = this.includes ? this.includes.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetFeedbackQuestionsDtosRequest {
        const json = this.toJSON();
        let result = new GetFeedbackQuestionsDtosRequest();
        result.init(json);
        return result;
    }
}

export class GetFeedbackQuestionsDtosListRequest extends GetFeedbackQuestionsDtosRequest {
    skip?: number | undefined;
    take?: number | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): GetFeedbackQuestionsDtosListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackQuestionsDtosListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skip"] = this.skip;
        data["take"] = this.take;
        super.toJSON(data);
        return data; 
    }

    clone(): GetFeedbackQuestionsDtosListRequest {
        const json = this.toJSON();
        let result = new GetFeedbackQuestionsDtosListRequest();
        result.init(json);
        return result;
    }
}

export class GetFeedbackQuestionDtosQuery extends GetFeedbackQuestionsDtosListRequest {
    idLanguage?: number;
    idFeedbackQuestionGroup?: number | undefined;
    idFeedback?: number | undefined;
    typeId?: number | undefined;
    search?: string;
    orderBy?: GetFeedbackQuestionsDtosOrderOptions | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idFeedbackQuestionGroup = _data["idFeedbackQuestionGroup"];
            this.idFeedback = _data["idFeedback"];
            this.typeId = _data["typeId"];
            this.search = _data["search"];
            this.orderBy = _data["orderBy"];
        }
    }

    static fromJS(data: any): GetFeedbackQuestionDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackQuestionDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idFeedbackQuestionGroup"] = this.idFeedbackQuestionGroup;
        data["idFeedback"] = this.idFeedback;
        data["typeId"] = this.typeId;
        data["search"] = this.search;
        data["orderBy"] = this.orderBy;
        super.toJSON(data);
        return data; 
    }

    clone(): GetFeedbackQuestionDtosQuery {
        const json = this.toJSON();
        let result = new GetFeedbackQuestionDtosQuery();
        result.init(json);
        return result;
    }
}

export enum GetFeedbackQuestionsDtosOrderOptions {
    TitleAsc = 0,
    TitleDesc = 1,
    Reflection = 2,
    OrderId = 3,
    OrderIdDesc = 4,
    TypeId = 5,
    TypeIdDesc = 6,
}

export class GetFeedbackQuestionsDtosIncludeOptions {
    feedbackQuestionGroup?: boolean;
    feedbackQuestionType?: boolean;

    init(_data?: any) {
        if (_data) {
            this.feedbackQuestionGroup = _data["feedbackQuestionGroup"];
            this.feedbackQuestionType = _data["feedbackQuestionType"];
        }
    }

    static fromJS(data: any): GetFeedbackQuestionsDtosIncludeOptions {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackQuestionsDtosIncludeOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feedbackQuestionGroup"] = this.feedbackQuestionGroup;
        data["feedbackQuestionType"] = this.feedbackQuestionType;
        return data; 
    }

    clone(): GetFeedbackQuestionsDtosIncludeOptions {
        const json = this.toJSON();
        let result = new GetFeedbackQuestionsDtosIncludeOptions();
        result.init(json);
        return result;
    }
}

export class GetSingleFeedbackQuestionDtoQuery extends GetFeedbackQuestionsDtosListRequest {
    idLanguage?: number;
    idFeedbackQuestion?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idFeedbackQuestion = _data["idFeedbackQuestion"];
        }
    }

    static fromJS(data: any): GetSingleFeedbackQuestionDtoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSingleFeedbackQuestionDtoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idFeedbackQuestion"] = this.idFeedbackQuestion;
        super.toJSON(data);
        return data; 
    }

    clone(): GetSingleFeedbackQuestionDtoQuery {
        const json = this.toJSON();
        let result = new GetSingleFeedbackQuestionDtoQuery();
        result.init(json);
        return result;
    }
}

export class GetFeedbackQuestionTypesDtosQuery {
    idLanguage?: number;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
        }
    }

    static fromJS(data: any): GetFeedbackQuestionTypesDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackQuestionTypesDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        return data; 
    }

    clone(): GetFeedbackQuestionTypesDtosQuery {
        const json = this.toJSON();
        let result = new GetFeedbackQuestionTypesDtosQuery();
        result.init(json);
        return result;
    }
}

export class GetFeedbackQuestionTypesDtosRequest {
    includes?: GetFeedbackQuestionTypesDtosIncludeOptions | undefined;

    init(_data?: any) {
        if (_data) {
            this.includes = _data["includes"] ? GetFeedbackQuestionTypesDtosIncludeOptions.fromJS(_data["includes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFeedbackQuestionTypesDtosRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackQuestionTypesDtosRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includes"] = this.includes ? this.includes.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetFeedbackQuestionTypesDtosRequest {
        const json = this.toJSON();
        let result = new GetFeedbackQuestionTypesDtosRequest();
        result.init(json);
        return result;
    }
}

export class GetFeedbackQuestionTypesDtosListRequest extends GetFeedbackQuestionTypesDtosRequest {
    skip?: number | undefined;
    take?: number | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): GetFeedbackQuestionTypesDtosListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackQuestionTypesDtosListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skip"] = this.skip;
        data["take"] = this.take;
        super.toJSON(data);
        return data; 
    }

    clone(): GetFeedbackQuestionTypesDtosListRequest {
        const json = this.toJSON();
        let result = new GetFeedbackQuestionTypesDtosListRequest();
        result.init(json);
        return result;
    }
}

export class GetSingleFeedbackQuestionTypeDtoQuery extends GetFeedbackQuestionTypesDtosListRequest {
    idLanguage?: number;
    idFeedbackQuestionType?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idFeedbackQuestionType = _data["idFeedbackQuestionType"];
        }
    }

    static fromJS(data: any): GetSingleFeedbackQuestionTypeDtoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSingleFeedbackQuestionTypeDtoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idFeedbackQuestionType"] = this.idFeedbackQuestionType;
        super.toJSON(data);
        return data; 
    }

    clone(): GetSingleFeedbackQuestionTypeDtoQuery {
        const json = this.toJSON();
        let result = new GetSingleFeedbackQuestionTypeDtoQuery();
        result.init(json);
        return result;
    }
}

export class GetFeedbackQuestionTypesDtosIncludeOptions {

    init(_data?: any) {
    }

    static fromJS(data: any): GetFeedbackQuestionTypesDtosIncludeOptions {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackQuestionTypesDtosIncludeOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): GetFeedbackQuestionTypesDtosIncludeOptions {
        const json = this.toJSON();
        let result = new GetFeedbackQuestionTypesDtosIncludeOptions();
        result.init(json);
        return result;
    }
}

export class GetFeedbacksDtosRequest {
    includes?: GetFeedbacksDtosIncludeOptions | undefined;

    init(_data?: any) {
        if (_data) {
            this.includes = _data["includes"] ? GetFeedbacksDtosIncludeOptions.fromJS(_data["includes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFeedbacksDtosRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbacksDtosRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includes"] = this.includes ? this.includes.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetFeedbacksDtosRequest {
        const json = this.toJSON();
        let result = new GetFeedbacksDtosRequest();
        result.init(json);
        return result;
    }
}

export class GetFeedbacksDtosListRequest extends GetFeedbacksDtosRequest {
    skip?: number | undefined;
    take?: number | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): GetFeedbacksDtosListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbacksDtosListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skip"] = this.skip;
        data["take"] = this.take;
        super.toJSON(data);
        return data; 
    }

    clone(): GetFeedbacksDtosListRequest {
        const json = this.toJSON();
        let result = new GetFeedbacksDtosListRequest();
        result.init(json);
        return result;
    }
}

export class GetFeedbackDtosQuery extends GetFeedbacksDtosListRequest {
    idFeedback?: number;
    idLanguage?: number;
    idFeedbackType?: number | undefined;
    idUser?: number | undefined;
    idAppGroup?: number | undefined;
    title?: string | undefined;
    search?: string | undefined;
    resolved?: number | undefined;
    orderBy?: GetFeedbacksDtosOrderOptions | undefined;
    period?: GetFeedbacksDtosPeriodOptions;
    privacy?: GetFeedbacksDtosPrivacyOptions;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idFeedback = _data["idFeedback"];
            this.idLanguage = _data["idLanguage"];
            this.idFeedbackType = _data["idFeedbackType"];
            this.idUser = _data["idUser"];
            this.idAppGroup = _data["idAppGroup"];
            this.title = _data["title"];
            this.search = _data["search"];
            this.resolved = _data["resolved"];
            this.orderBy = _data["orderBy"];
            this.period = _data["period"];
            this.privacy = _data["privacy"];
        }
    }

    static fromJS(data: any): GetFeedbackDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedback"] = this.idFeedback;
        data["idLanguage"] = this.idLanguage;
        data["idFeedbackType"] = this.idFeedbackType;
        data["idUser"] = this.idUser;
        data["idAppGroup"] = this.idAppGroup;
        data["title"] = this.title;
        data["search"] = this.search;
        data["resolved"] = this.resolved;
        data["orderBy"] = this.orderBy;
        data["period"] = this.period;
        data["privacy"] = this.privacy;
        super.toJSON(data);
        return data; 
    }

    clone(): GetFeedbackDtosQuery {
        const json = this.toJSON();
        let result = new GetFeedbackDtosQuery();
        result.init(json);
        return result;
    }
}

export enum GetFeedbacksDtosOrderOptions {
    TitleAsc = 0,
    TitleDesc = 1,
    DateCreatedAsc = 2,
    DateCreatedDesc = 3,
    DateStartAsc = 4,
    DateStartDesc = 5,
}

export enum GetFeedbacksDtosPeriodOptions {
    All = 0,
    Today = 1,
    Week = 2,
    Month = 3,
}

export enum GetFeedbacksDtosPrivacyOptions {
    Mine = 1,
    All = 2,
}

export class GetFeedbacksDtosIncludeOptions {
    feedbackType?: boolean;
    user?: boolean;
    feedbackQuestionGroup?: boolean;
    appGroupVsFeedback?: boolean;

    init(_data?: any) {
        if (_data) {
            this.feedbackType = _data["feedbackType"];
            this.user = _data["user"];
            this.feedbackQuestionGroup = _data["feedbackQuestionGroup"];
            this.appGroupVsFeedback = _data["appGroupVsFeedback"];
        }
    }

    static fromJS(data: any): GetFeedbacksDtosIncludeOptions {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbacksDtosIncludeOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feedbackType"] = this.feedbackType;
        data["user"] = this.user;
        data["feedbackQuestionGroup"] = this.feedbackQuestionGroup;
        data["appGroupVsFeedback"] = this.appGroupVsFeedback;
        return data; 
    }

    clone(): GetFeedbacksDtosIncludeOptions {
        const json = this.toJSON();
        let result = new GetFeedbacksDtosIncludeOptions();
        result.init(json);
        return result;
    }
}

export class GetSingleFeedbackDtoQuery extends GetFeedbacksDtosListRequest {
    idLanguage?: number;
    idFeedback?: number;
    idUserRequest?: number;
    idUserResponse?: number;
    idFeedbackType?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idFeedback = _data["idFeedback"];
            this.idUserRequest = _data["idUserRequest"];
            this.idUserResponse = _data["idUserResponse"];
            this.idFeedbackType = _data["idFeedbackType"];
        }
    }

    static fromJS(data: any): GetSingleFeedbackDtoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSingleFeedbackDtoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idFeedback"] = this.idFeedback;
        data["idUserRequest"] = this.idUserRequest;
        data["idUserResponse"] = this.idUserResponse;
        data["idFeedbackType"] = this.idFeedbackType;
        super.toJSON(data);
        return data; 
    }

    clone(): GetSingleFeedbackDtoQuery {
        const json = this.toJSON();
        let result = new GetSingleFeedbackDtoQuery();
        result.init(json);
        return result;
    }
}

export class GetFeedbackTypesDtosQuery {
    idLanguage?: number;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
        }
    }

    static fromJS(data: any): GetFeedbackTypesDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackTypesDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        return data; 
    }

    clone(): GetFeedbackTypesDtosQuery {
        const json = this.toJSON();
        let result = new GetFeedbackTypesDtosQuery();
        result.init(json);
        return result;
    }
}

export class GetSingleFeedbackTypeDtoQuery {
    idLanguage?: number;
    idFeedbackType?: number;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idFeedbackType = _data["idFeedbackType"];
        }
    }

    static fromJS(data: any): GetSingleFeedbackTypeDtoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSingleFeedbackTypeDtoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idFeedbackType"] = this.idFeedbackType;
        return data; 
    }

    clone(): GetSingleFeedbackTypeDtoQuery {
        const json = this.toJSON();
        let result = new GetSingleFeedbackTypeDtoQuery();
        result.init(json);
        return result;
    }
}

export class GetSingleFeedbackVsUser180DtoQuery extends GetFeedbacksDtosListRequest {
    idLanguage?: number;
    idFeedbackVsUser180?: number;
    idFeedback?: number;
    idUserRequest?: number;
    idUserResponse?: number;
    feedbackAnswer?: string;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idFeedbackVsUser180 = _data["idFeedbackVsUser180"];
            this.idFeedback = _data["idFeedback"];
            this.idUserRequest = _data["idUserRequest"];
            this.idUserResponse = _data["idUserResponse"];
            this.feedbackAnswer = _data["feedbackAnswer"];
        }
    }

    static fromJS(data: any): GetSingleFeedbackVsUser180DtoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSingleFeedbackVsUser180DtoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idFeedbackVsUser180"] = this.idFeedbackVsUser180;
        data["idFeedback"] = this.idFeedback;
        data["idUserRequest"] = this.idUserRequest;
        data["idUserResponse"] = this.idUserResponse;
        data["feedbackAnswer"] = this.feedbackAnswer;
        super.toJSON(data);
        return data; 
    }

    clone(): GetSingleFeedbackDtoQuery {
        const json = this.toJSON();
        let result = new GetSingleFeedbackDtoQuery();
        result.init(json);
        return result;
    }
}

export class GetLanguagesDtosQuery {

    init(_data?: any) {
    }

    static fromJS(data: any): GetLanguagesDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguagesDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): GetLanguagesDtosQuery {
        const json = this.toJSON();
        let result = new GetLanguagesDtosQuery();
        result.init(json);
        return result;
    }
}

export class GetMetadataFieldDtosQuery {
    idLanguage?: number;
    idMetadataGroup?: number | undefined;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idMetadataGroup = _data["idMetadataGroup"];
        }
    }

    static fromJS(data: any): GetMetadataFieldDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMetadataFieldDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idMetadataGroup"] = this.idMetadataGroup;
        return data; 
    }

    clone(): GetMetadataFieldDtosQuery {
        const json = this.toJSON();
        let result = new GetMetadataFieldDtosQuery();
        result.init(json);
        return result;
    }
}

export class GetMetadataFieldOptionDtosQuery {
    idLanguage?: number;
    idMetadataField?: number;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idMetadataField = _data["idMetadataField"];
        }
    }

    static fromJS(data: any): GetMetadataFieldOptionDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMetadataFieldOptionDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idMetadataField"] = this.idMetadataField;
        return data; 
    }

    clone(): GetMetadataFieldOptionDtosQuery {
        const json = this.toJSON();
        let result = new GetMetadataFieldOptionDtosQuery();
        result.init(json);
        return result;
    }
}

export class GetMetadataGroupDtosQuery {
    idLanguage?: number;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
        }
    }

    static fromJS(data: any): GetMetadataGroupDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMetadataGroupDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        return data; 
    }

    clone(): GetMetadataGroupDtosQuery {
        const json = this.toJSON();
        let result = new GetMetadataGroupDtosQuery();
        result.init(json);
        return result;
    }
}

export class GlobalSearchDtoQuery {
    idLanguage?: number;
    keyword?: string;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.keyword = _data["keyword"];
        }
    }

    static fromJS(data: any): GlobalSearchDtoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalSearchDtoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["keyword"] = this.keyword;
        return data; 
    }

    clone(): GlobalSearchDtoQuery {
        const json = this.toJSON();
        let result = new GlobalSearchDtoQuery();
        result.init(json);
        return result;
    }
}

export class GetProfileDtoQuery {
    idLanguage?: number;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
        }
    }

    static fromJS(data: any): GetProfileDtoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfileDtoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        return data; 
    }

    clone(): GetProfileDtoQuery {
        const json = this.toJSON();
        let result = new GetProfileDtoQuery();
        result.init(json);
        return result;
    }
}

export class GetUserCommentsDtosQuery {
    idLanguage?: number;
    idUser?: number;
    isPublic?: boolean | undefined;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idUser = _data["idUser"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): GetUserCommentsDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserCommentsDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idUser"] = this.idUser;
        data["isPublic"] = this.isPublic;
        return data; 
    }

    clone(): GetUserCommentsDtosQuery {
        const json = this.toJSON();
        let result = new GetUserCommentsDtosQuery();
        result.init(json);
        return result;
    }
}

export class GetUsersDtosRequest {
    includes?: GetUsersDtosIncludeOptions | undefined;

    init(_data?: any) {
        if (_data) {
            this.includes = _data["includes"] ? GetUsersDtosIncludeOptions.fromJS(_data["includes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUsersDtosRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersDtosRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includes"] = this.includes ? this.includes.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetUsersDtosRequest {
        const json = this.toJSON();
        let result = new GetUsersDtosRequest();
        result.init(json);
        return result;
    }
}

export class GetUsersDtosSingleRequest extends GetUsersDtosRequest {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetUsersDtosSingleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersDtosSingleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): GetUsersDtosSingleRequest {
        const json = this.toJSON();
        let result = new GetUsersDtosSingleRequest();
        result.init(json);
        return result;
    }
}

export class GetUserDtoQuery extends GetUsersDtosSingleRequest {
    idUser?: number;
    idLanguage?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idUser = _data["idUser"];
            this.idLanguage = _data["idLanguage"];
        }
    }

    static fromJS(data: any): GetUserDtoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserDtoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUser"] = this.idUser;
        data["idLanguage"] = this.idLanguage;
        super.toJSON(data);
        return data; 
    }

    clone(): GetUserDtoQuery {
        const json = this.toJSON();
        let result = new GetUserDtoQuery();
        result.init(json);
        return result;
    }
}

export class GetUsersDtosIncludeOptions {
    entity?: boolean;
    parent?: boolean;
    userType?: boolean;
    metadata?: boolean;
    appGroups?: boolean;

    init(_data?: any) {
        if (_data) {
            this.entity = _data["entity"];
            this.parent = _data["parent"];
            this.userType = _data["userType"];
            this.metadata = _data["metadata"];
            this.appGroups = _data["appGroups"];
        }
    }

    static fromJS(data: any): GetUsersDtosIncludeOptions {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersDtosIncludeOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity;
        data["parent"] = this.parent;
        data["userType"] = this.userType;
        data["metadata"] = this.metadata;
        data["appGroups"] = this.appGroups;
        return data; 
    }

    clone(): GetUsersDtosIncludeOptions {
        const json = this.toJSON();
        let result = new GetUsersDtosIncludeOptions();
        result.init(json);
        return result;
    }
}

export class GetUserLoginsDtosQuery {
    idUser?: number;

    init(_data?: any) {
        if (_data) {
            this.idUser = _data["idUser"];
        }
    }

    static fromJS(data: any): GetUserLoginsDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserLoginsDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUser"] = this.idUser;
        return data; 
    }

    clone(): GetUserLoginsDtosQuery {
        const json = this.toJSON();
        let result = new GetUserLoginsDtosQuery();
        result.init(json);
        return result;
    }
}

export class GetUserLogsDtosQuery {
    idUser?: number;
    typeId?: UserLogTypes | undefined;

    init(_data?: any) {
        if (_data) {
            this.idUser = _data["idUser"];
            this.typeId = _data["typeId"];
        }
    }

    static fromJS(data: any): GetUserLogsDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserLogsDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUser"] = this.idUser;
        data["typeId"] = this.typeId;
        return data; 
    }

    clone(): GetUserLogsDtosQuery {
        const json = this.toJSON();
        let result = new GetUserLogsDtosQuery();
        result.init(json);
        return result;
    }
}

export enum UserLogTypes {
    Created = 0,
    Edited = 1,
}

export class GetUserMetadataDtoQuery {
    idUser?: number;
    idLanguage?: number;

    init(_data?: any) {
        if (_data) {
            this.idUser = _data["idUser"];
            this.idLanguage = _data["idLanguage"];
        }
    }

    static fromJS(data: any): GetUserMetadataDtoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserMetadataDtoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUser"] = this.idUser;
        data["idLanguage"] = this.idLanguage;
        return data; 
    }

    clone(): GetUserMetadataDtoQuery {
        const json = this.toJSON();
        let result = new GetUserMetadataDtoQuery();
        result.init(json);
        return result;
    }
}

export class GetUsersDtosListRequest extends GetUsersDtosRequest {
    skip?: number | undefined;
    take?: number | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): GetUsersDtosListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersDtosListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skip"] = this.skip;
        data["take"] = this.take;
        super.toJSON(data);
        return data; 
    }

    clone(): GetUsersDtosListRequest {
        const json = this.toJSON();
        let result = new GetUsersDtosListRequest();
        result.init(json);
        return result;
    }
}

export class GetUsersDtosQuery extends GetUsersDtosListRequest {
    idLanguage?: number;
    idAppInterface?: number | undefined;
    orderBy?: GetUsersDtosOrderOptions | undefined;
    name?: string | undefined;
    email?: string | undefined;
    nationality?: string | undefined;
    contactDefault?: string | undefined;
    idAppGroups?: string | undefined;
    idUserType?: number | undefined;
    idEntity?: number | undefined;
    age?: number | undefined;
    minimumAge?: number | undefined;
    maximumAge?: number | undefined;
    metadata?: string | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idAppInterface = _data["idAppInterface"];
            this.orderBy = _data["orderBy"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.nationality = _data["nationality"];
            this.contactDefault = _data["contactDefault"];
            this.idAppGroups = _data["idAppGroups"];
            this.idUserType = _data["idUserType"];
            this.idEntity = _data["idEntity"];
            this.age = _data["age"];
            this.minimumAge = _data["minimumAge"];
            this.maximumAge = _data["maximumAge"];
            this.metadata = _data["metadata"];
        }
    }

    static fromJS(data: any): GetUsersDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idAppInterface"] = this.idAppInterface;
        data["orderBy"] = this.orderBy;
        data["name"] = this.name;
        data["email"] = this.email;
        data["nationality"] = this.nationality;
        data["contactDefault"] = this.contactDefault;
        data["idAppGroups"] = this.idAppGroups;
        data["idUserType"] = this.idUserType;
        data["idEntity"] = this.idEntity;
        data["age"] = this.age;
        data["minimumAge"] = this.minimumAge;
        data["maximumAge"] = this.maximumAge;
        data["metadata"] = this.metadata;
        super.toJSON(data);
        return data; 
    }

    clone(): GetUsersDtosQuery {
        const json = this.toJSON();
        let result = new GetUsersDtosQuery();
        result.init(json);
        return result;
    }
}

export enum GetUsersDtosOrderOptions {
    NameAsc = 0,
    NameDesc = 1,
    EmailAsc = 2,
    EmailDesc = 3,
    ContactDefaultAsc = 4,
    ContactDefaultDesc = 5,
    DateCreatedAsc = 6,
    DateCreatedDesc = 7,
}

export class GetUserTypeMetadataGroupsConfigurationDtoQuery {
    idLanguage?: number;
    idUserType?: number;
    visibleOnCreate?: boolean | undefined;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idUserType = _data["idUserType"];
            this.visibleOnCreate = _data["visibleOnCreate"];
        }
    }

    static fromJS(data: any): GetUserTypeMetadataGroupsConfigurationDtoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserTypeMetadataGroupsConfigurationDtoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idUserType"] = this.idUserType;
        data["visibleOnCreate"] = this.visibleOnCreate;
        return data; 
    }

    clone(): GetUserTypeMetadataGroupsConfigurationDtoQuery {
        const json = this.toJSON();
        let result = new GetUserTypeMetadataGroupsConfigurationDtoQuery();
        result.init(json);
        return result;
    }
}

export class GetUserTypesDtosQuery {
    idLanguage?: number;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
        }
    }

    static fromJS(data: any): GetUserTypesDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserTypesDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        return data; 
    }

    clone(): GetUserTypesDtosQuery {
        const json = this.toJSON();
        let result = new GetUserTypesDtosQuery();
        result.init(json);
        return result;
    }
}